//var $ = require('jquery');
//var validation = require('jquery-validation');
//var unobtrusiveValidation = require('jquery-validation-unobtrusive');
//var gritter = require('gritter');
//var ladda = require('ladda');

export default class Val {

    public static displayErrors(responseText:any, validationSummarySelector = null) {
        if (responseText === "")
            return;

        var error = '';
        var focusOnId = '';
        
        if (typeof(responseText) === 'string') {
            error = responseText;
        }
        
        // we probably have already parsed json into JS objects from axios
        if (typeof responseText === 'object' && !Array.isArray(responseText) && responseText !== null)
        {
            for (var prop in responseText) {
                // important check that this is objects own property 
                // not from prototype prop inherited
                if (responseText.hasOwnProperty(prop)) {
                    if (index === 0)
                        focusOnId = prop;
                    
                    error += responseText[prop] + "<br />";
                    
                    $("#" + prop).addClass('invalid is-invalid').removeClass('valid is-valid');

                    $('[data-valmsg-for="' + prop + '"]')
                        .removeClass('field-validation-valid')
                        .addClass('field-validation-invalid')
                        .html(responseText[prop][0]);
                    
                    index++;
                }
            }
        }

        if (error !== '') {
            $(validationSummarySelector ?? ".display-errors").html(error).removeClass('d-none');
         
            if (focusOnId !== '') {
                $("#" + focusOnId).trigger('focus');
            } else {
                //$('html, body').animate({ scrollTop: 0 }, 'slow');
            }
        }
        
        return;
        
        var data = JSON.parse(responseText); // parse the response into a JavaScript object

       
        

        if (!$.isEmptyObject(data.Errors)) {
            var index = 0;
            for (var prop in data.Errors) {
                // important check that this is objects own property 
                // not from prototype prop inherited
                if (data.Errors.hasOwnProperty(prop)) {
                    if (index === 0)
                        focusOnId = prop;
                    error += data.Errors[prop] + "<br />";
                    index++;
                }
            }
        } else if (!$.isEmptyObject(data.modelState)) {
            var index = 0;
            for (var prop in data.modelState) {
                if (data.modelState.hasOwnProperty(prop)) {
                    var errors = data.modelState[prop].Errors;
                    for (var prop2 in errors) {
                        if (errors.hasOwnProperty(prop2)) {
                            error += data.modelState[prop].Errors[prop2] + "<br />";
                        }
                    }
                }
                index++;
            }
        } else {

            // for cases where model state errors are returned from api controllers.
            if (!$.isEmptyObject(data.ModelState)) {
                for (var prop in data.ModelState) {
                    // important check that this is objects own property 
                    // not from prototype prop inherited
                    if (data.ModelState.hasOwnProperty(prop)) {
                        error += data.ModelState[prop] + "<br />";
                    }
                }
            } else if (data.ExceptionMessage) {
                error = data.ExceptionMessage;
            //} else if (data.Message) {
            //    error = data.Message;
            //    // cases where a message/exceptionMessage is passed
            } else if (!$.isEmptyObject(data)) {
                var index = 0;

                // THIS IS JUST A STOP GAP UNTIL CLIENT SIDE VALIDATION IS WORKING FOR FLUENT VALIDATION IN .NET CORE
               
                // clear out any errors we displayed previously - they may have turned valid now
                $(".invalid").removeClass('invalid');
                $('.field-validation-invalid').removeClass('field-validation-invalid').html('');

                for (var prop in data) {
                    if (prop === '') {
                        error += "<li>" + data[prop][0] + "</li>";
                    } else {
                        if (index === 0)
                            focusOnId = prop;
                        // important check that this is objects own property 
                        // not from prototype prop inherited
                        if (data.hasOwnProperty(prop)) {
                            $("#" + prop).addClass('invalid is-invalid').removeClass('valid is-valid');

                            $('[data-valmsg-for="' + prop + '"]')
                                .removeClass('field-validation-valid')
                                .addClass('field-validation-invalid')
                                .html(data[prop][0]);
                            error += data[prop][0] + "<br /><br />";
                        }
                        index++;
                    }
                }

                if (focusOnId !== '') {
                    $("#" + focusOnId).focus();
                } else {
                    //$('html, body').animate({ scrollTop: 0 }, 'slow');
                }
            }
        }

        if (error !== '') {
            $(validationSummarySelector ?? ".display-errors").html(error).removeClass('d-none');
            // show the error
            //$.gritter.add({
            //    title: 'Error',
            //    text: error,
            //    class_name: 'gritter-error'
            //});

            if (focusOnId !== '') {
                $("#" + focusOnId).focus();
            } else {
                //$('html, body').animate({ scrollTop: 0 }, 'slow');
            }
        }
    }
}